import { z } from 'zod'

import { zSelect } from 'Lib/zod'

import { FORM_MESSAGES_MAP } from 'Constants/formMessages'

import { ShippingAddressTypeEnum } from 'Types/address/address.types'

import { SHIPPING_ADDRESS_FORM_ZIPCODE_MIN_CHARACTERS } from './ShippingAddressForm.constants'

const baseShippingAddressFormSchema = z.object({
  _label: z.string(),
  addressType: z.nativeEnum(ShippingAddressTypeEnum),
  city: z.string().min(1, FORM_MESSAGES_MAP.REQUIRED),
  country: zSelect.refine(arg => !!arg?.value, FORM_MESSAGES_MAP.REQUIRED),
  name: z.string().min(1, FORM_MESSAGES_MAP.REQUIRED),
  nameAddition: z.string(),
  streetNumber: z.string().min(1, FORM_MESSAGES_MAP.REQUIRED),
  zipcode: z
    .string()
    .min(
      SHIPPING_ADDRESS_FORM_ZIPCODE_MIN_CHARACTERS,
      FORM_MESSAGES_MAP.MIN_LENGTH,
    ),
})

export const shippingAddressFormSchema = baseShippingAddressFormSchema.merge(
  z.object({
    street: z.string().min(1, FORM_MESSAGES_MAP.REQUIRED),
  }),
)

export const usShippingAddressFormSchema = baseShippingAddressFormSchema.merge(
  z.object({
    address: z.string().min(1, FORM_MESSAGES_MAP.REQUIRED),
  }),
)
